import UIActionTypes from './types'

const INITIAL_STATE = {
  loading: false,
  alertMessage: '',
  currentSegment: {},
  imageBanner: '',
  gameStageWindow: 'startWindow',
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case UIActionTypes.ENABLE_LOADING:
    return { 
      ...state, 
      loading: true, 
    }
  case UIActionTypes.DISABLE_LOADING:
    return { 
      ...state, 
      loading: false, 
    }
  case UIActionTypes.UI_CLEAN_STATE:
    return { 
      ...INITIAL_STATE, 
    }
  case UIActionTypes.UPDATE_ALERT_MESSAGE:
    return { 
      ...state, 
      alertMessage: action.payload, 
    }
  case UIActionTypes.UPDATE_GAME_STAGE:
    return { 
      ...state,
      gameStageWindow: action.payload,
    }
  case UIActionTypes.UPDATE_CURRENT_SEGMENT:
    return { 
      ...state,
      currentSegment: action.payload,
    }
  case UIActionTypes.UPDATE_IMAGE_BANNER: {
    return { 
      ...state, 
      imageBanner: action.payload, 
    }
  }
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/entities/ui/reducers.js